/**
 * Vuex "home" module.
 *
 * Aggregates the feed/post-related store slice used by the home feed,
 * profile pages, and search: state (store.js), actions (operations.js),
 * getters (selectors.js), and mutations (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
